import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { TagsFilter } from "~/components/Filters/TagsFilter/TagsFilter";
import { PrivatePopularTags } from "~/components/Tags/PrivatePopularTags";
import { PrivateTagsSelect } from "~/components/Tags/PrivateTagsSelect";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { clearTagsFilterValuesAction, setTagsFilterLogicAction, setTagsFiltersValueAction } from "~/store/filters/actions";
import { hasTagsFiltersValuesSelector, selectedTagsFilterLogicSelector, selectedTagsFiltersSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleTagFilter = /*#__PURE__*/ memo((param)=>{
    let { onApplyClick } = param;
    const dispatch = useDispatch();
    const hasValues = useAirSelector(hasTagsFiltersValuesSelector);
    const { searchImprovements } = useTemporaryFeatureFlags();
    const clearValues = useCallback(()=>{
        dispatch(clearTagsFilterValuesAction());
    }, [
        dispatch
    ]);
    const selectedLogic = useSelector(selectedTagsFilterLogicSelector);
    const selectedTags = useSelector(selectedTagsFiltersSelector);
    const onLogicChange = useCallback((logic)=>dispatch(setTagsFilterLogicAction({
            logic
        })), [
        dispatch
    ]);
    const onSelectedTagsChanged = useCallback((tags)=>{
        dispatch(setTagsFiltersValueAction({
            tags
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    const onTagClick = useCallback((tag)=>{
        dispatch(setTagsFiltersValueAction({
            tags: [
                tag
            ]
        }));
        onApplyClick();
    }, [
        dispatch,
        onApplyClick
    ]);
    return /*#__PURE__*/ _jsxs(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "tags",
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: [
            /*#__PURE__*/ _jsx(TagsFilter, {
                TagsSelect: PrivateTagsSelect,
                selectedLogic: selectedLogic,
                selectedTags: selectedTags,
                onLogicChange: onLogicChange,
                onSelectedTagsChanged: onSelectedTagsChanged
            }),
            !selectedTags.length && searchImprovements && /*#__PURE__*/ _jsx(PrivatePopularTags, {
                className: "mt-3",
                onTagClick: onTagClick
            })
        ]
    });
});
SingleTagFilter.displayName = "SingleTagFilter";
